import {reactive} from 'vue';
// import {buildTimestamp, version} from "@/version.js";

// const env = import.meta.env.VITE_ENVIRONMENT || '';
//
// // State variables
// export const systemInfo = reactive({
//     appName: 'BGN TV Remote',
//     version: version + (env && env !== 'prd' ? ` | ${env}` : ''),
//     buildTimestamp: buildTimestamp || '...',
//     prizeData: {},
//     handshakeSettings: {},
//     handshakeInfo: {},
//
//     test: {
//         testLine1: "test line 1",
//         testNestedObject: {
//             testNestedObjectLine1: "test nested object line 1",
//             testNestedObjectLine2: "test nested object line 2",
//             testNestedObjectLine3: "test nested object line 3",
//         },
//         testLine2: "test line 2"
//     }
// });

// Parameters used in multiple places throughout app
export const params = {
    backgroundSrc: 'blade_background-lg_blur.webm',      // App background video source file
    backgroundSpeed: 0.4,           // Background video playback speed
    startupWait: 3,                 // Time in S to wait at startup screen before proceeding to home screen
    cols: 5,                        // Number of grid columns
    autoLaunchTimeout: 120,         // Time in S before default app launches
    modalTimeout: 20,               // Time in S before modals auto close
    menuTimeout: 60,                // Time in S before menu auto close
    appStartTimeout: 30,            // Time in S to wait to timeout app launch -- communication failure
    thxTimeout: 60,                 // Time in S to wait before going back to home screen after hosted game ends
    dimTimeout: 5,                  // Time in S before UI dims -- to be nice to OLED displays
    gameIdInputTime: 120,           // Time in S for host to enter game ID before returning to home screen
    gameIdValidationTimeout: 30,    // Time in S to wait to timeout game ID validation
    communicationAttemptRetries: 5, // Number of times to retry sending system info
    baseRetryDelay: 2,              // Time in S to progressively back off retries
}
